import templateUrl from './dashboardNavController.tpl.html';

export default [
    function () {
        return {
            templateUrl,
        };
    },
];
